export default [
  {
    path: '/deregister',
    name: 'deregister',
    component: () => import('@simple/views/deregister/deregister.vue'),
  },
  {
    path: "/protocal-deregister",
    name: "protocal-deregister",
    component: () => import("@simple/views/teacher/protocal/protocal-deregister.vue"),
}
];
